module.exports = __webpack_public_path__ + "img/water-meter-with-circle.9449448b.png";